module.exports = __webpack_public_path__ + "img/kuang7@2x.2c0be4f0.png";